import { render } from "./proforma-invoice-modal.vue?vue&type=template&id=b6a9e982&scoped=true"
import script from "./proforma-invoice-modal.vue?vue&type=script&lang=js"
export * from "./proforma-invoice-modal.vue?vue&type=script&lang=js"

import "./proforma-invoice-modal.vue?vue&type=style&index=0&id=b6a9e982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a9e982"]])

export default __exports__